import dayjs from 'dayjs';
import React from 'react';

interface SelectedDateDisplayProps {
  date: Date;
  onViewAll?: () => void;
  showCalendar?: boolean;
}

const SelectedDateDisplay: React.FC<SelectedDateDisplayProps> = ({ date, onViewAll, showCalendar }) => {
  return (
    <div className="md:hidden mb-4 p-3 bg-white border border-gray-200 rounded-lg shadow-sm">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-gray-800">{dayjs(date).format('MMMM D, YYYY')}</span>
        <button onClick={onViewAll} className="text-xs px-2 py-1 rounded-md bg-btn text-btn-text transition">
          {showCalendar ? 'Hide Calendar' : 'View Calendar'}
        </button>
      </div>
    </div>
  );
};

export default SelectedDateDisplay;
